<template>
  <section class="pt-lg-3 pb-0 border">
    <div class="d-flex pb-0 justify-content-between px-3 align-items-end">
      <div class="thumbImage col-4 pb-0 d-none d-md-inline-block"></div>
      <div class="col-12 col-md-8 col-lg-6 text-center pb-3 pt-4">
        <div class="embedded mb-4 d-md-none"></div>
        <h2 class="h3 mb-3 pb-2 text-dark">Schnell & einfach deine Küche verkaufen</h2>
        <p class="pb-2">
          Mit wirkaufendeine-kueche.de hast Du den perfekten Ansprechpartner für Deinen Küchenverkauf gefunden.
          Unser Küchenankauf möchte das Küchen verkaufen so schnell und unkompliziert wie möglich gestalten.
          Eine erste Werteinschätzung erhälst du über unser Online-Bewertungstool. Danach einfach online einen Termin zur individuellen Begutachtung
          Deiner Küche ausmachen. Unsere Experten teilen Dir anschließend den endgültigen Verkaufspreis mit. Auf Wunsch, umgehender Verkauf und Bezahlung,
          schnell und ohne Stress.
        </p>
        <button class="btn btn-dark btn-shadow mb-3" @click="scrollToEval">Jetzt bewerten</button>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: 'explain',
  components: {
  },
  data: () => ({
  }),
  computed: {
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    scrollToEval: function () {
      const id = "evaluationCard";
      let element = document.getElementById(id);
      if (element !== null) {
        element.scrollIntoView();
      }
    }, 
  }
}
</script>

<style scoped>
.thumbImage {
  background-image: url("/img/myDesigns/pictures/thumbsUp-smallerPixel.png"); /* The image used */
  height: 350px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
}
.embedded {
  background-image: url("/img/myDesigns/pictures/thumbsUp-smallerPixel.png"); /* The image used */
  height: 200px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
}
</style>